<script lang="ts">
  interface Props {
    /** 0..1, matching the audio bus scale. */
    value: number;
    label: string;
    onchange: (value: number) => void;
    disabled?: boolean;
    segments?: number;
  }

  let { value, label, onchange, disabled = false, segments = 10 }: Props = $props();

  const percent = $derived(Math.round(Math.min(Math.max(value, 0), 1) * 100));
  const filled = $derived(Math.round((percent / 100) * segments));

  function handle(event: Event): void {
    const next = Number((event.currentTarget as HTMLInputElement).value);
    if (Number.isFinite(next)) onchange(next / 100);
  }
</script>

<!--
  The blocks are presentation; the control underneath is a native range input,
  kept in the layout rather than hidden so it keeps its keyboard handling, its
  focus ring and its screen-reader semantics. Reimplementing a slider with
  divs is how arrow keys and drag-off-the-edge stop working.
-->
<div class="opt optslider" class:optslider--disabled={disabled}>
  <label class="optslider__head" for="slider-{label}">
    <span class="optrow__label">{label}</span>
    <span class="optslider__value">{percent}%</span>
  </label>

  <div class="optslider__track">
    {#each { length: segments } as _, index (index)}
      <i class="optslider__seg" class:optslider__seg--on={index < filled}></i>
    {/each}
    <input
      id="slider-{label}"
      class="optslider__input"
      type="range"
      min="0"
      max="100"
      step="10"
      value={percent}
      {disabled}
      aria-label={label}
      oninput={handle}
    />
  </div>
</div>
